import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function NFIMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();

  const [wrongLenMemNum, setWrongLenMemNum] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    {
      key: "MEMBERSHIP_NUM",
      value: t("CRR.ContractSearch.DropdownOptions3"),
    },
    {
      key: "PHONE",
      value: t("FIMC.ContractSearch.DropdownOptions2"),
    },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("MEMBERSHIP_NUM");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");
  const [phone, setPhone] = useState(props.phone || "");

  // useEffect(() => {
  //   devLog(selectedSearchTypes);
  //   // setVehicleId(vehicleId);
  //   // setLicensePlate(licensePlate);
  //   setMemberNumber(memberNumber);
  //   setLast8Vin(last8Vin);
  // }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        memberNumber: memberNumber,
        phone: phone,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (memberNumber.length < 10 && selectedSearchTypes === "MEMBERSHIP_NUM") {
      setWrongLenMemNum(true);
      return;
    }

    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        memberNumber: memberNumber,
        phone: phone,
        firstName: firstName,
        lastName: lastName,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const memNumInputLength = (e) => {
    setWrongLenMemNum(false);
    if (e.target.value.length > 11) {
      e.target.value = e.target.value.slice(0, -1);
      const t = e.target.value;
      devLog("t: ", t);
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              background: "#303030",
              color: "white",
              padding: "6px 12px 6px 12px",
              border: "1px solid rgba(0, 0, 0, 0.15)",
              borderRadius: ".25rem",
            }}
          >
            {t("CRR.ContractSearch.DropdownOptions3")}
          </div> */}

          {/*Membership Number*/}
          {selectedSearchTypes === "MEMBERSHIP_NUM" && (
            <>
              <div className="group-1">
                <div className="label">{t("CRR.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  // placeholder={t("CRR.ContractSearch.DropdownOptions3")}
                  placeholder="Ex: MEM0000000"
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    memNumInputLength(e);
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {wrongLenMemNum && <Alert severity="error">{t("description.MembershipNumberError")}</Alert>}
            </>
          )}

          {/*Phone Number*/}
          {selectedSearchTypes === "PHONE" && (
            <>
              <div className="group-1">
                <div className="label">{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="text"
                  name="phone"
                  className="input form-control required"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default NFIMemberSearchForm;
